import * as CookieNames from '../utils/constants'

export const eStorageKey = {
  userData: CookieNames.UserData,
  accessToken: CookieNames.AccessToken,
  refreshToken: CookieNames.RefreshToken,
  temporaryToken: CookieNames.TemporaryToken
}
